import React from 'react';
import classNames from "classnames";
import {orderBy} from "lodash";
import {DeliveryLocationDetail, deliveryLocations} from "../../../../../../src/shared/utils/deliveryLocation.utils";
import styled from "styled-components";
import {DeliveryLocation} from "../../../../../__generated__/types";


const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-auto-rows: max-content;
  grid-gap: 8px;
  margin-bottom: 32px;
  padding: 4px;

  @media only screen and (min-width: 800px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: 4px;
  }

  &.compact {
    grid-template-columns: 1fr;
    grid-gap: 8px;
    margin-bottom: 0;
    padding: 0;

    @media only screen and (min-width: 520px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  &.p-invalid {
    border: 1px solid var(--invalid);
  }
`;

const DeliveryLocationOption = styled.div`
  border: 1px solid var(--green);
  display: grid;
  grid-template-columns: 50px 1fr;
  grid-gap: 16px;
  padding: 8px;
  align-items: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;

  @media only screen and (max-width: 500px) {
    padding: 6px;
    grid-gap: 8px;
    font-size: 90%;
  }

  &.compact {
    border-color: var(--green-40);
    grid-template-columns: 42px 1fr;
    padding: 10px;
  }

  &:hover {
    opacity: 1;
    background-color: var(--green-20);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }

  &:not(.static) {
    cursor: pointer;

    &:hover, &.selected {
      opacity: 1;
      background-color: var(--green-40);
      border-width: 2px;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
      transform: translateY(-1px);
    }
  }

  img {
    border-radius: 50%;
    overflow: hidden;
    max-width: 50px;
    max-height: 50px;
    object-fit: cover;
  }

  &.compact img {
    max-width: 42px;
    max-height: 42px;
  }

  label {
    display: grid;
    grid-template-columns: max-content max-content;
    grid-gap: 4px;
    align-items: center;
  }

  .city {
    font-weight: bold;
    text-transform: uppercase;
    color: var(--green);
    line-height: 1.2;
  }

  .address {
    line-height: 1.3;
  }
`;

interface DeliveryLocationsProps {
  onClick?: (deliveryLocationOption: DeliveryLocationDetail) => void;
  onMouseEnter?: (deliveryLocationOption: DeliveryLocationDetail) => void;
  onMouseLeave?: () => void;
  value?: DeliveryLocation;
  field?: any;
  static: boolean;
  hideAddress?: boolean;
  compact?: boolean;
  filters?: (deliveryLocation: DeliveryLocationDetail) => void;
}

const DeliveryLocations = (props: DeliveryLocationsProps) => {
  const meta = props.field && props.field[1];

  const isFormFieldValid = () => props.field && !!((meta.touched) && meta.error);
  let collection = deliveryLocations;
  if (props.filters) {
    collection = collection.filter(props.filters);
  }
  return <Container className={classNames({'p-invalid': isFormFieldValid(), compact: props.compact})}>
    {orderBy(collection, [(deliveryLocation => deliveryLocation.value === DeliveryLocation.WEELDE), 'label'], ['desc', 'asc']).map(deliveryLocationOption =>
      <DeliveryLocationOption
        key={deliveryLocationOption.value}
        onClick={() => props.onClick && props.onClick(deliveryLocationOption)}
        onMouseEnter={() => props.onMouseEnter && props.onMouseEnter(deliveryLocationOption)}
        onMouseLeave={() => props.onMouseLeave && props.onMouseLeave()}
        className={classNames({
          selected: props.value === deliveryLocationOption.value,
          static: props.static,
          compact: props.compact,
        })}
      >
        <img src={'/deliveryLocations/' + deliveryLocationOption.logo} alt={deliveryLocationOption.name}/>
        <div>
          <div className={'city'}>{deliveryLocationOption.city}</div>
          <div className={'address'}>{deliveryLocationOption.name}</div>
          {!props.hideAddress && <div className={'address'}>{deliveryLocationOption.address}</div>}
        </div>
      </DeliveryLocationOption>)}
  </Container>;
};

export default DeliveryLocations;
